<template>
  <b-container>
    <b-row>
      <b-col>
        <AdminNavigation
          :currentTab="subtab"
          @changeAdminTab="changeAdminTab"
        ></AdminNavigation>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12" class="content_container">
        <Loading v-if="$store.state.loading"></Loading>
        <transition name="fade">

          <StylePage
            v-if="subtab === 'style' && !$store.state.loading"
          ></StylePage>
        </transition>
        <transition name="fade">
          <InfosParcours
            v-if="subtab === 'parcours' && !$store.state.loading"
          ></InfosParcours>
        </transition>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import AdminNavigation from "@/components/Admin_tab/AdminNavigation.vue";
import StylePage from "@/components/Admin_tab/StylePage.vue";
import InfosParcours from "@/components/Admin_tab/InfosParcours.vue";
export default {
  components: { AdminNavigation, StylePage, InfosParcours },
  data() {
    return {
      subtab: "style",
    };
  },
  methods: {
    changeAdminTab(t) {
      this.subtab = t;
    },
  },
};
</script>

<style lang="sass" scoped>
</style>